export default __webpack_public_path__ + "static/media/bank_sber.448863e7.svg";